import { palette } from '../../palette';
import { StatusChip } from '../../components/StatusChip';
import { PayoutWorklistStatus } from './types';

interface StatusBadgeProps {
  status: string;
}

const API_STATUS_LABEL_MAP: Record<string, string> = {
  COMPLETED: 'Completed',
  IN_PROGRESS: 'In Progress',
  BLOCKED: 'Blocked',
  INVITE_SENT: 'Invite Sent',
  NOT_STARTED: 'Not Started',
  NOT_APPLICABLE: 'Not Applicable',
};

const SUCCESS_STATUSES = new Set<string>([
  PayoutWorklistStatus.OnboardingCompleted,
  PayoutWorklistStatus.Paid,
  PayoutWorklistStatus.PaidExternally,
  PayoutWorklistStatus.CheckCleared,
  PayoutWorklistStatus.DeliveredToAddress,
  'Paid Externally',
]);

const FAILED_STATUSES = new Set<string>([
  PayoutWorklistStatus.Failed,
  PayoutWorklistStatus.OnboardingExpired,
  PayoutWorklistStatus.DistributionCancelled,
  PayoutWorklistStatus.StopPaymentInitiated,
  'BLOCKED',
]);

const SUCCESS_API_STATUSES = new Set<string>(['COMPLETED']);

export const getReadablePayoutStatus = (status: string) => {
  const normalizedStatus = status?.trim().toUpperCase();
  return API_STATUS_LABEL_MAP[normalizedStatus] || status;
};

export const getPayoutStatusColor = (status: string) => {
  const normalizedStatus = status?.trim().toUpperCase();

  if (SUCCESS_API_STATUSES.has(normalizedStatus)) {
    return palette.success.main;
  }

  return SUCCESS_STATUSES.has(status)
    ? palette.success.main
    : FAILED_STATUSES.has(status)
      ? palette.error.main
      : palette.warning.main;
};

const StatusBadge = ({ status }: StatusBadgeProps) => {
  const color = getPayoutStatusColor(status);

  return <StatusChip label={getReadablePayoutStatus(status)} color={color} />;
};

export default StatusBadge;
